export const STORNO_GRANT      = 'M__ProjectPatternStorno';
export const STORNO_LIST_GRANT = 'M__ProjectPatternStornoList';

export const ACTION_TYPE = Object.freeze({
  STORNO:         'storno',
  STORNO_PARTIAL: 'storno_partial',
  CORRECTION:     'correction',
  SEND_SMETA:     'send_smeta',
});

export const STORNO_MESSAGES = Object.freeze({
  NO_CHANGES:         'Нет изменений для корректировки',
  FACT_LIMITED:       'Новый факт ограничен остатком по работе',
  WILL_APPLY_ON_SEND: 'Будет применена при отправке в УСП.',
  FULL_STORNO:        'Полное сторно зарегистрировано',
  SAVE_ERROR:         'Ошибка сохранения корректировки',
  GROUP_SAVE_ERROR:   'Ошибка сохранения групповой корректировки',
  NO_RECORD_IN_DB:    'Запись не найдена в БД',
});

export const ACTION_LABEL = Object.freeze({
  [ACTION_TYPE.STORNO]:         'Сторно',
  [ACTION_TYPE.STORNO_PARTIAL]: 'Сторнирование (частичное)',
  [ACTION_TYPE.CORRECTION]:     'Корректировка',
  [ACTION_TYPE.SEND_SMETA]:     'Смета',
});
